module.exports = __webpack_public_path__ + "img/success_stars@3x.46c1b5b7.png";